<template>
	<div class="menu">
		<div class="top">
			<router-link to="/" :class="{selected: ($route.name == 'Home')}">
				<i class="fa fa-home"></i>
				<span>Home</span>
			</router-link>

			<router-link to="/servers" :class="{selected: ($route.name == 'Servers')}">
				<i class="fa fa-server"></i>
				<span>Servers</span>
			</router-link>

			<router-link to="/wipes" :class="{selected: ($route.name == 'Wipes')}">
				<i class="fa fa-calendar-alt"></i>
				<span>Wipes</span>
			</router-link>

			<router-link to="/donate" :class="{selected: ($route.name == 'Donate')}">
				<i class="fa fa-donate"></i>
				<span>Donate</span>
			</router-link>
		</div>

		<div class="bottom">
			<a href="https://discord.gg/QUZvG6b" target="_blank">
				<i class="fab fa-discord"></i>
				<span>Discord</span>
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: "Menu",
};
</script>


<style lang="scss">
.menu {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100px;
	position: absolute;
	left: calc(100% + 20px);
	top: 0px;
	height: 100%;

	a {
		display: block;
		text-align: center;
		margin-bottom: 15px;
		transition: 0.25s;
		color: white;
		opacity: 0.5;

		&:last-child {
			margin-bottom: 0px;
		}
		.fa-discord {
			font-size: 40px;
		}

		&.selected,
		&:hover {
			opacity: 1;

			span {
				color: white;
			}
		}

		i {
			display: block;
			font-size: 48px;
			margin-bottom: 3px;
			transition: 0.25s;
		}

		span {
			font-size: 12px;
			color: rgba(255, 255, 255, 0.5);
			transition: 0.25s;
			font-weight: 700;
		}
	}
}
</style>